<ui-card class="padding-4" [withMargin]="false">
    <!-- Top of the component where we show the current month and year and the hours tracked -->
    <div class="flex margin-bottom-3">
        <div class="month-date-box flex col align-items-center justify-center">
            <div class="date">{{ dayOfMonth }}</div>
            <div class="month">{{ abbreviatedMonth }}</div>
        </div>
        <div class="hours-worked-box flex col space-between">
            <div class="day-of-week">{{ dayOfTheWeek }}</div>
            <div class="today">{{ timeWorkedToday }}</div>
            <div class="yesterday">{{ 'time-tracking.yesterday' | appTranslate }}: {{ timeWorkedYesterday }}</div>
        </div>
    </div>

    <hr />

    <!-- Bottom of the component where we show the buttons -->
    <div class="buttons-box margin-top-3" #buttonsBox style="--max-width: {{ buttonMaxWidth }}">
        <ui-button url="/time-tracking/my-timesheet/create" type="primary" size="full-width">
            {{ 'time-tracking.dashboardWidget.enterHoursButton' | translate }}
        </ui-button>
        <ui-button url="/time-tracking/my-timesheet" type="outline" size="full-width">
            {{ 'time-tracking.dashboardWidget.viewMyTimesheetButton' | translate }}
        </ui-button>
    </div>
</ui-card>
